// Traduce las acciones crudas del log de auditoría (`security_health_checked`,
// `data_update`...) a texto legible, y arma la línea de detalle que las
// acompaña (nombre del ítem, IP, método...).
//
// El texto de cada acción vive en `audit.actions.<action>` dentro de
// client/src/i18n/locales/{es,en}.json — esto es solo el fallback para una
// acción nueva que el servidor empiece a emitir y todavía no esté traducida,
// y el formateador del detalle.

function toSentenceCase(value) {
  if (!value) return '';
  const spaced = String(value).replace(/_/g, ' ');
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

// Etiqueta legible de una acción de auditoría.
export function getActionLabel(t, action) {
  return t(`audit.actions.${action}`, toSentenceCase(action));
}

// Etiqueta legible de un motivo de fallo (`details.reason`). Algunos motivos
// ya llegan en texto humano ("Tarjeta inactiva") y esos se muestran tal cual;
// los que llegan en snake_case ("card_already_exists_with_same_id") se
// traducen vía `audit.reasons.<reason>` con el mismo fallback.
function getReasonLabel(t, reason) {
  if (!reason) return '';
  if (!reason.includes('_')) return reason;
  return t(`audit.reasons.${reason}`, toSentenceCase(reason));
}

// Línea de detalle de un registro de auditoría: lo que distingue esta entrada
// de otra con la misma acción. No repite lo que ya dice la etiqueta.
export function getActionDetail(t, log) {
  const d = log?.details || {};
  const m = log?.metadata || {};
  const parts = [];

  const subject =
    d.name || d.itemName || d.fileName || d.cardName || d.alias || d.newAlias ||
    d.email || d.deviceName || d.identifier;
  if (subject) parts.push(subject);

  if (d.reason) parts.push(getReasonLabel(t, d.reason));
  if (d.method) parts.push(d.method);
  if (d.provider) parts.push(d.provider);
  if (d.type && typeof d.type === 'string') parts.push(d.type);

  if (typeof d.totalItems === 'number') parts.push(t('audit.detail.items', { count: d.totalItems }));
  if (typeof d.deletedCount === 'number') parts.push(t('audit.detail.deleted', { count: d.deletedCount }));
  if (typeof d.count === 'number') parts.push(`${d.count}`);

  if (m.success === false) parts.push(t('audit.labels.failed'));

  if (log?.ipAddress) parts.push(log.ipAddress);

  return parts.filter(Boolean).join(' · ');
}
